module.exports = __webpack_public_path__ + "media/images/flags/4x3/iot-21130dd44abbb1d2649399ab302eda2f.svg";